import { Suspense } from 'react';
import { lazily } from 'react-lazily';

import { AppLayout } from '.';
import { AppContent } from '../../app/app-content';
import { App as TopNavbar } from '../../modules/top-navbar/components/App';
import { MobileActionBar } from '../action-bar/mobile-action-bar';

const { GlobalModals } = lazily(() => import('../../app/global-modals'));

export const AppRootLayout = () => (
	<AppLayout navbar={<TopNavbar />}>
		<Suspense>
			<GlobalModals />
		</Suspense>

		<AppContent />
		<MobileActionBar />
	</AppLayout>
);
